import { defineComponent, reactive, computed, ref, nextTick } from 'vue';
import { gsap } from 'gsap';
import { Helper } from '@hems/util';
import IncreasingNumberLabel from '@/components/labels/IncreasingNumberLabel.vue';
export default defineComponent({
    name: 'EnergyBalanceOverview',
    components: { IncreasingNumberLabel },
    props: {
        data: {
            type: Object,
            required: true,
        },
        locale: {
            type: String,
            required: false,
            default: 'en',
        },
    },
    setup(props) {
        const overBox = ref(null);
        const state = reactive({
            unit: 'kWh',
            over: true,
        });
        const energyBalanceOverviewData = computed(() => props.data);
        async function onEnter(e) {
            const target = e.target;
            const left = target.offsetLeft;
            const width = target.offsetWidth;
            await gsap.set([overBox.value], {
                left,
                width,
            });
            gsap.to([overBox.value], {
                opacity: '1',
                transition: 'all .1s opacity .1s',
            });
        }
        async function onLeave() {
            await gsap.to([overBox.value], {
                opacity: '0',
                transition: 'all .1s, opacity .1s',
            });
            state.over = false;
            nextTick(() => {
                state.over = true;
            });
        }
        return { state, overBox, Helper, onLeave, onEnter, energyBalanceOverviewData };
    },
});
